import { useMemo } from "react";
import { resolveDomainConfig } from "@/lib/domainConfig";

/**
 * Returns the active domain config based on `window.location.hostname`.
 * For development/preview: a `?domain=<hostname>` query parameter overrides
 * the real hostname so we can test focused-domain experiences from the
 * preview URL before the custom domains are wired up.
 */
export const useDomain = () => {
  return useMemo(() => {
    if (typeof window === "undefined") return resolveDomainConfig("");
    let hostname = window.location.hostname;
    try {
      const params = new URLSearchParams(window.location.search);
      const override = params.get("domain");
      if (override) hostname = override;
    } catch (_) {
      /* ignore */
    }
    return resolveDomainConfig(hostname);
  }, []);
};
